<template>
    <ion-row v-if="entry && entry.item" class="remove-col-x-padding">
        <ion-col class="fw-b">
            {{ entry.item.name }}
        </ion-col>

        <ion-col size="auto">
            {{ entry.item.packaging }}
        </ion-col>
    </ion-row>

    <ion-row v-if="entry && entry.item" class="stacked-cols remove-col-x-padding">
        <ion-col size="auto" class="fixed-width-xxs-screen">
            <div class="fs-smaller grey1-grey1-color">{{ $t('object.amount') }}</div>
            <div class="fw-b">
                {{ entry.quantity }}
            </div>
        </ion-col>

        <ion-col>
            <template v-if="Number(entry.item.price)">
                <div class="fs-smaller grey1-grey1-color">{{ $t('object.price') }}</div>
                <div class="fw-b">
                    {{ convertNumberWithComma(Number(entry.item.price).toFixed(3)) }} {{ CURRENCY_EUR }}
                </div>
            </template>
        </ion-col>

        <ion-col size="4" class="ion-text-end">
            <template v-if="!Number((entry.item.price ?? 0) * entry.quantity)">
                <!-- Ticket #6289 -->

                <!-- Bei Lieferanten, deren Schnittstellen keine Preisübermittlung unterstützen, darf im Warenkorb
                    in der Bestellübersicht kein Hinweis „Preisinformation nicht verfügbar“ angezeigt werden. -->

                <!-- <div class="fs-smaller grey1-grey1-color break-word">{{ $t('object.notAvailable') }}</div> -->
            </template>
            <div v-else class="fw-b max-size">
                <div class="fs-smaller grey1-grey1-color">{{ $t('object.totalPosition') }}</div>
                <div style="margin-top: 0.5rem;">
                    {{ convertNumberWithComma(Number((entry.item.price ?? 0) * entry.quantity).toFixed(3)) }} {{ CURRENCY_EUR }}
                </div>
            </div>
        </ion-col>
    </ion-row>
</template>

<script setup lang="ts">
import { IonCol, IonRow } from "@ionic/vue";

import { convertNumberWithComma } from "@/functions/converter";

import { CURRENCY_EUR } from "@/assets/variables";

import { ListItem } from "@/types/supplier";

defineProps<{ entry: ListItem }>()
</script>
